import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/TabBar';
import ExportsTab from './ExportsTab';

export default function AdminExportsPage() {
  const navigate = useNavigate();
  return (
    <div className="screen">
      <div className="obsbar">
        <button className="obsbar-back" onClick={() => navigate('/')}>← Back</button>
        <div className="obsbar-title">Exports</div>
      </div>
      <div className="scroll">
        <div className="pad"><ExportsTab /></div>
      </div>
      <TabBar current="exports" />
    </div>
  );
}
